import PropTypes from "prop-types";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const CFormPhoneNumberField = React.forwardRef(
  (
    {
      label,
      disabled,
      name,
      type,
      helperText,
      handleChange,
      multiline,
      customClassName,
      ...other
    },
    ref
  ) => {
    const { control } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <div className={`custom-input phone-input ${customClassName}`}>
            <label className="upload-label !mb-1 block">{label}</label>
            <div className=" focus-within:border-blue-500 input-phone">
              <PhoneInput
                {...other}
                placeholder="Enter phone number"
                defaultCountry="US"
                value={value}
                onChange={(value) => {
                  onChange(value); // Ensure the value is updated in react-hook-form
                }}
                international
                className="w-full outline-none bg-white"
              />
            </div>
            {error && <p className="text-sm text-[#d32f2f] !text-[13px] !mt-1">{error.message}</p>}
          </div>
        )}
      />
    );
  }
);

CFormPhoneNumberField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};
export default CFormPhoneNumberField;
